import { Button } from "@devhop/ui";
import { Eye } from "lucide-react";

type MeetingRowItemProps = {
  title: string;
  meetingDate: string;
  status: "upcoming" | "past";
  summary: string | null;
  organizerName: string | null;
  onOpen?: () => void;
};

function looksLikeHtml(text: string) {
  return /<\/?[a-z][\s\S]*>/i.test(text);
}

export function MeetingRowItem({
  title,
  meetingDate,
  status,
  summary,
  organizerName,
  onOpen,
}: MeetingRowItemProps) {
  return (
    <div className="grid items-start gap-3 py-4 md:grid-cols-[1fr_160px_180px_80px]">
      <div>
        <p className="font-medium text-lg">{title}</p>
        {summary ? (
          looksLikeHtml(summary) ? (
            // biome-ignore-start lint/security/noDangerouslySetInnerHtml: allow meeting summary html content
            <div
              className="mt-1 text-muted-foreground text-sm"
              dangerouslySetInnerHTML={{ __html: summary }}
            />
            // biome-ignore-end lint/security/noDangerouslySetInnerHtml: allow meeting summary html content
          ) : (
            <p className="mt-1 whitespace-pre-line text-muted-foreground text-sm">
              {summary}
            </p>
          )
        ) : (
          <p className="mt-1 text-muted-foreground text-sm">ບໍ່ມີສະຫຼຸບ</p>
        )}
      </div>

      <div>
        <p className="text-[10px] text-muted-foreground uppercase">
          ວັນທີກອງປະຊຸມ
        </p>
        <p className="text-sm">{meetingDate}</p>
      </div>

      <div>
        <p className="text-[10px] text-muted-foreground uppercase">
          ສະຖານະ / ຜູ້ຈັດ
        </p>
        <p className="text-sm">
          <span
            className={`rounded px-2 py-0.5 text-xs uppercase ${status === "upcoming" ? "bg-black text-white" : "bg-muted text-muted-foreground"}`}
          >
            {status === "upcoming" ? "ຈະມາເຖິງ" : "ຜ່ານມາ"}
          </span>
        </p>
        <p className="mt-1 text-muted-foreground text-xs">
          {organizerName ?? "—"}
        </p>
      </div>

      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="size-8"
        onClick={onOpen}
      >
        <Eye className="size-4" />
      </Button>
    </div>
  );
}
